import axios from 'axios';
import request from '../../services/request';

/**
 * #196360 한국산업기술진흥원 KPASS로 로그인
 * @param {string} url KPASS 인증 주소
 * @param {{ name: string, birth: string, email: string }} payload 사용자 정보를 UrlSearchParams로 보낸다.
 * @returns {result: "officialDocSuccess"} 성공시 받는 값
 */
export async function kpassLogin(url, payload) {
  const res = await axios
    .post(url, payload, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    })
    .catch((error) => {
      if (error.response) {
        throw new Error('txt.kpass.server-error');
      }
    });
  return res;
}

/**
 * #196360 KPASS OTP 코드 발급 요청
 * @param {{ name: string, telephoneNumber: string }} payload otp 발급 정보
 * @returns { success: boolean, errorType: string, data: {expireDate: Date} || [{ name: [], errors: [{ id: string; }] }]}
 */
export async function kpassOtpGenerate(payload) {
  const res = await request.post('/portal/api/auth/otp/generate', payload);
  return res.data;
}

/**
 * #196360 KPASS OTP 코드 검증
 * @param {{ name: string, birth: number, email: string, telephoneNumber: string, otpNumber: string }} payload otp 발급 정보
 * @returns { success: boolean, errorType: string, data: {token: string} || [{ name: [], errors: [{ id: string; }] }]}
 */
export async function kpassOtpVerify(payload) {
  const res = await request.post('/portal/api/auth/otp/verify', payload);
  return res.data;
}

/**
 * #196707#note-9 KPASS 서버에 개인정보 동의 DB 업데이트
 * @param {{ infoAgreeYn: "Y", pledgeYn: "Y"}} payload Y 고정값으로 전달한다.
 * @returns
 */
export async function kpassEvalCert(payload) {
  const res = await request.post('/evalCert.do', payload);
  return res;
}

/**
 * #196707#note-9 KPASS 서버에 휴대폰 인증 완료 DB 업데이트
 * @param {string} payload 인증받은 OTP 넘버를 전달한다.
 * @returns
 */
export async function kpassEvalSuccess(payload) {
  const res = await request.post('/eval/success.do', payload);
  return res;
}
